import React from "react";

import Show from "./show";

import { connect } from "react-redux";

import { isUserOwner } from "../../../../redux/actions/config/session";

import {
    load,
    getData,
    isLoaded,
    isLoading,
    getError,
    reset,
    removeTaskFromPOVendor,
    downloadFile,
    acceptPurchaseOrder,
    revertPurchaseOrder,
    includeRectification,
    deleteRectification,
    isSecondaryLoading,
    addInvoice,
    downloadInvoice,
    confirmInvoice,
    revertInvoice,
    removeInvoice,
} from "../../../../redux/actions/manager/purchaseOrder/show";

import {
    CACHE_SERVICE,
    CACHE_CATLOG,
    CACHE_VENDOR,
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    getServicesById,
    getCatlogValueNameById,
    getVendorsById,
} from "../../../../redux/actions/cache/interface";

import Loader from "../../../../components/loader";
import { PURCHASE_ORDER_STATUS_IN_REVIEW } from "../../../../config/const";

/**
 * Container:
 *
 *   Se encarga de la conexion entre Redux y el Componente  que presenta los datos
 *
 * De paso en algunos caso, excepto formularios se maneja el Loading y el título.
 *
 * OBS: En formularios es mejor que el 'loading' lo maneje el formulario dado que Formik
 *    si se redibuja pierde los datos, entonces hay que tener cuidado con eso.
 */
class Container extends React.Component {
    /**
     * Parametros
     *  - id:  Se asume que el ID viene por la URL
     */
    constructor(props) {
        super(props);
        this.state = { id: props.match.params.id };
    }

    componentDidMount() {
        this.props.loadCache();
        this.props.load(this.state.id);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    _goBack = () => {
        this.props.history.goBack();
    };

    render() {
        const { loading, loaded, data, actionLoading } = this.props;
        return (
            <>
                <Loader loading={loading || actionLoading} />
                {!loading && data && loaded && (
                    <Show {...this.props} allowEdit={data.purchaseOrder.status == PURCHASE_ORDER_STATUS_IN_REVIEW} />
                )}
            </>
        );
    }
}

const cacheList = [CACHE_SERVICE, CACHE_CATLOG, CACHE_VENDOR];

function MapStateToProps(state) {
    return {
        error: getError(state),
        loading: isLoading(state) || isCacheLoading(state, cacheList),
        actionLoading: isSecondaryLoading(state),
        loaded: isLoaded(state) && isCacheLoaded(state, cacheList),
        data: getData(state),
        servicesById: getServicesById(state),
        vendorsById: getVendorsById(state),
        getCatlogValueNameById: getCatlogValueNameById(state),

        isOwner: isUserOwner(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => loadCache(cacheList)(dispatch),
        load: (id) => dispatch(load(id)),
        reset: () => dispatch(reset()),
        removeTaskFromPOVendor: (poId, potId) => dispatch(removeTaskFromPOVendor(poId, potId)),
        downloadFile: (id, name) => dispatch(downloadFile(id, name)),

        acceptPurchaseOrder: (id) => dispatch(acceptPurchaseOrder(id)),
        revertPurchaseOrder: (id) => dispatch(revertPurchaseOrder(id)),
        includeRectification: (poId, potId) => dispatch(includeRectification(poId, potId)),
        deleteRectification: (poId, potId) => dispatch(deleteRectification(poId, potId)),

        addInvoice: (id, form) => dispatch(addInvoice(id, form)),
        downloadInvoice: (id, name) => dispatch(downloadInvoice(id, name)),
        confirmInvoice: (id, invoiceId) => dispatch(confirmInvoice(id, invoiceId)),
        revertInvoice: (id, invoiceId) => dispatch(revertInvoice(id, invoiceId)),
        removeInvoice: (id, invoiceId) => dispatch(removeInvoice(id, invoiceId)),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
